import React, { useState } from "react";
import { useUserContext } from "../../utils/UserContext";
import { tincPermis } from "../../utils/Permisos";
import Seleccionargrupsmaobra from "./Seleccionargrupsmaobra";
import Detallsgrupsmaobra from "./Detallsgrupsmaobra";
import "../dashboard_v2.css";
import AjudaMestres from "./AjudaMestres";
import { BotoAjuda } from "./AjudaModal";

function idGrup(g) {
  return g ? Number(g.idGrupMaObra) : null;
}

function Grupsmaobra() {
  const { rolUsuari } = useUserContext();
  const potAccedir = tincPermis(rolUsuari, "ACCES");

  const [activeTab, setActiveTab] = useState("seleccionar");
  const [selectedGrup, setSelectedGrup] = useState(null);
  const [filterText, setFilterText] = useState("");
  const [grupsLlista, setGrupsLlista] = useState([]);
  const [reloadToken, setReloadToken] = useState(0);
  const [mostraAjuda, setMostraAjuda] = useState(false);

  const tornarLlista = (refresca = false) => {
    setActiveTab("seleccionar");
    if (refresca) setReloadToken((n) => n + 1);
  };

  const handleGrupSelect = (grup) => {
    if (!grup) {
      setSelectedGrup(null);
      return;
    }
    setSelectedGrup((prev) => (idGrup(prev) === idGrup(grup) ? null : grup));
  };

  const obrirFitxa = (grup, mode) => {
    setSelectedGrup(grup);
    setActiveTab(mode);
  };

  if (!potAccedir) {
    return (
      <div className="dv2 dv2-page">
        <p className="dv2-empty">No tens permisos per accedir a aquesta pantalla.</p>
      </div>
    );
  }

  const esLlista = activeTab === "seleccionar";

  return (
    <div className="dv2 dv2-page dv2-page--fill">
      {mostraAjuda && <AjudaMestres pestanya="grupsmaobra" onTancar={() => setMostraAjuda(false)} />}
      {esLlista ? (
        <>
          <div className="dv2-pageHeader">
            <div className="dv2-pageHeader-main">
              <div className="dv2-pageHeader-icon" aria-hidden="true">
                👥
              </div>
              <div>
                <h1 className="dv2-pageHeader-title">Grups de mà d'obra</h1>
                <p className="dv2-pageHeader-subtitle">Composició de tipus i preu del grup.</p>
              </div>
            </div>
            <div className="dv2-pageHeader-actions">
              <BotoAjuda title="Com funcionen els Grups de mà d'obra" onClick={() => setMostraAjuda(true)} />
              {tincPermis(rolUsuari, "CREAR") && (
                <button
                  type="button"
                  className="dv2-btn dv2-btn--primary"
                  onClick={() => {
                    setSelectedGrup(null);
                    setActiveTab("nou");
                  }}
                >
                  Nou grup
                </button>
              )}
            </div>
          </div>

          <Seleccionargrupsmaobra
            onGrupSelect={handleGrupSelect}
            onConsultar={(g) => obrirFitxa(g, "consultar")}
            onModificar={(g) => obrirFitxa(g, "modificar")}
            onEsborrar={(g) => obrirFitxa(g, "esborrar")}
            selectedGrup={selectedGrup}
            setGrupsLlista={setGrupsLlista}
            filterText={filterText}
            setFilterText={setFilterText}
            reloadToken={reloadToken}
          />
        </>
      ) : (
        <Detallsgrupsmaobra
          mode={activeTab}
          grup={activeTab === "nou" ? null : selectedGrup}
          grupsLlista={grupsLlista}
          onNavigate={setSelectedGrup}
          onCancel={() => tornarLlista(false)}
          onDeleted={() => tornarLlista(true)}
          onCanviarMode={setActiveTab}
          onSave={(updated) => {
            if (activeTab === "nou") {
              tornarLlista(true);
              return;
            }
            setSelectedGrup(updated);
            setGrupsLlista((prev) =>
              (prev || []).map((g) => (idGrup(g) === idGrup(updated) ? { ...g, ...updated } : g))
            );
            setActiveTab("consultar");
          }}
        />
      )}
    </div>
  );
}

export default Grupsmaobra;
